































































































































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { ASSET_URL } from '../../common/config';
import { CREATE_PRODUCT, SHOW_SNACKBAR } from '../../common/constants';
import Tag from '../../common/model/Tag';
import { ProductWrite } from '../../common/types';
import { eventBus } from '../../main';
import brandModule from '../../store/modules/brand.module';
import productModule from '../../store/modules/product.module';
import errorModule from '../../store/modules/error.module';
import tagModule from '../../store/modules/tag.module';
import AdminCreateTag from './AdminCreateTag.vue';

const intializeProduct: ProductWrite = {
  brand_id: '',
  title: '',
  description: '',
  image: '',
  tags: [],
};

@Component({
  components: {
    AdminCreateTag,
  },
})
export default class AdminProductCard extends Vue {
  @Prop() product: any;

  @Prop({ default: false }) isExpanded: boolean;

  localProduct: ProductWrite = intializeProduct;

  brandModule = brandModule;

  // New products do not have IDs assigned yet.
  isNewProduct = false;

  imageFile: null | File = null;

  coaFile: null | File = null;

  strainGroups = ['Sativa', 'Indica', 'Hybrid', 'Sativa or Indica'];

  showDeleteProductDialog = false;


  get lastUpdatedDate(): string {
    if (!this.product.created_on || this.isNewProduct) { return ''; }
    const date = new Date(this.product.created_on);
    return `Last Updated: ${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

  get coaFileUrl(): string {
    if (!this.product || !this.product.pdf_url) { return ''; }
    return `${ASSET_URL}${this.product.pdf_url}`;
  }


  async submitForm(): Promise<void> {
    if (!brandModule.brand) {
      return;
    }
    this.localProduct.brand_id = brandModule.brand.id;
    if (this.imageFile) {
      this.localProduct.image = this.imageFile.name;
    }
    if (this.isNewProduct) {
      await this.createProduct();
    } else {
      await this.updateProduct();
    }
    if (errorModule.hasError) {
      errorModule.clearError();
    }
  }

  async updateProduct(): Promise<void> {
    await productModule.updateProduct({
      product: this.localProduct,
      imageFile: this.imageFile,
      coaFile: this.coaFile,
    });
  }

  async deleteProduct(): Promise<void> {
    await productModule.deleteProduct(this.localProduct);
    if (errorModule.hasError) {
      errorModule.clearError();
    }
    eventBus.$emit(
      SHOW_SNACKBAR,
      `${this.localProduct.title} successfully deleted.`,
    );
    this.showDeleteProductDialog = false;
  }

  async createProduct(): Promise<void> {
    eventBus.$emit(CREATE_PRODUCT);
    await productModule.createProduct({
      product: this.localProduct,
      imageFile: this.imageFile,
      coaFile: this.coaFile,
    });
    this.localProduct = intializeProduct;
  }

  async mounted(): Promise<void> {
    this.isNewProduct = this.product.id === undefined;
    this.localProduct = this.product;
  }

  get availableTags(): Array<Tag> {
    return tagModule.tags;
  }

  get assetUrl(): string {
    if (this.product.image) {
      return `${ASSET_URL}${this.product.image}`;
    }
    return require('@/assets/admin/placeholder.jpg');
  }
}
